/**
 * Lista de sonidos disponibles
 */
const notificationSounds = [
  {
    id: "01",
    name: "Gaston clásico",
    type: "sine",
    frequencies: [640, 960],
    duration: 0.24,
    volume: 0.2,
    doubleTone: true
  },
  {
    id: "02",
    name: "Tic-tac elegante",
    type: "triangle",
    frequency: 720,
    duration: 0.1,
    volume: 0.12,
    doubleTone: false
  }
];

/**
 * Reproduce un sonido específico por su ID
 * @param {string} id - El ID del sonido a reproducir
 */
export function playSoundById(id) {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const sound = notificationSounds.find(s => s.id === id);

  if (!sound) {
    console.warn("Sonido no encontrado con id:", id);
    return;
  }

  if (sound.doubleTone) {
    sound.frequencies.forEach((freq, index) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      const delay = index * 0.25;

      oscillator.type = sound.type;
      oscillator.frequency.setValueAtTime(freq, ctx.currentTime + delay);
      gain.gain.setValueAtTime(sound.volume, ctx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + sound.duration);
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(ctx.currentTime + delay);
      oscillator.stop(ctx.currentTime + delay + sound.duration);
    });
  } else {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = sound.type;
    oscillator.frequency.setValueAtTime(sound.frequency, ctx.currentTime);
    gain.gain.setValueAtTime(sound.volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + sound.duration);
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start();
    oscillator.stop(ctx.currentTime + sound.duration);
  }
}
